export const trackJustUno = (eventName: string, data: any): void => {
  window.juapp =
    window.juapp ||
    function () {
      (window.juapp.q = window.juapp.q || []).push(arguments);
    };

  window.juapp(eventName, data);
};
